<template>
    <div>
        <template v-if="editMode">
            <i class="fa fa-edit"></i> Edit
        </template>
        Project Name: {{ bid.bid_project_name }}
        Amount: {{ bid.bid_amount | currency }}
        Scope Details: {{ bid.scope_details }}
        Estimated Date On-Site: {{ bid.estimated_date_onsite | moment("MM/DD/YYYY") }}
        Estimator / Project Engineer / Project Manager: {{ bid.estimator_name }}
    </div>
</template>

<script>
    export default {
        props: {

            bid: {
                type: Object,
                required: true,
            },

            editMode: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {

        },

        methods: {

        },
    }
</script>
